export default {
  user: JSON.parse(window.localStorage.getItem('user')) || false,
  email: JSON.parse(window.localStorage.getItem('email')) || false,
  company: JSON.parse(window.localStorage.getItem('company')) || false,
  neighborhood: JSON.parse(window.localStorage.getItem('neighborhood')) || false,
  rent: JSON.parse(window.localStorage.getItem('rent')) || false,
  rentPreRegistration: JSON.parse(window.localStorage.getItem('rent_pre_registration')) || false
}



// WEBPACK FOOTER //
// ./src/store/state.js